import React from 'react'

import AddIcon from 'static/images/icons/add-plus.svg'
import styles from './AddNewPatientButton.css'

const AddNewPatientButton = props =>
  (
    <div className={styles.callToAction}>
      <button
        className={styles.ctaButton}
        onClick={props.handleOnClick}
      >
        <div className={styles.ctaIcon}>
          <AddIcon />
        </div>
        <span className={styles.ctaText}>Add New Patient</span>
      </button>
    </div>
  )

export default AddNewPatientButton



// WEBPACK FOOTER //
// ./src/legacy/components/AddNewPatientButton/AddNewPatientButton.jsx